import { useNetwork } from "../../context/NetworkContext";

export default function OfflineAlert() {
    const { online, apiOnline } = useNetwork();

    if (online && apiOnline) return null;

    const message = !online
        ? "Sem conexão com a internet"
        : "Servidor indisponível. Tente novamente em instantes.";

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            background: "#b00020",
            color: "white",
            textAlign: "center",
            padding: "10px",
            zIndex: 9999,
            fontSize: "14px",
            fontWeight: 600,
        }}>
            {message}
        </div>
    );
}
